import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import template from '@/../templates/device-filter-layout.hbs';


    var globalCh = Radio.channel('global');

    var DeviceFilterModel = Backbone.Model.extend( {
        defaults : {
            'assignment'       : false, // 'assigned' or 'unasssigned'
            'product'          : false, // Product
            'owner'            : false, // Owner
            'devicegroup'      : false, // Devicegroup
            'devicegroup_type' : false, // Devicegroup_type
            'account'          : false  // Account
        },
        calculate : function() {
            var filter = {
                'sort':'-last_enrolled_at'
            };
            var active = globalCh.request('active_account');

            if ( this.get('assignment') === 'unassigned' ) {
                filter['filter[owner.id]'] =  active.id;
                filter['filter[devicegroup.owner.id]'] = 'null';
                return filter;
            }

            if ( this.get('assignment') === 'assigned' ) {
                filter['filter[devicegroup.owner.id]'] = active.id;
                return filter;
            }

            if ( this.get('devicegroup') ) {
                filter['filter[devicegroup.id]'] = this.get('devicegroup').id;
                return filter;
            }

            if ( this.get('product') && this.get('devicegroup_type') ) {
                filter['filter[product.id]'] = this.get('product').id;
                filter['filter[devicegroup.type]'] = this.get('devicegroup_type');
                return filter;
            }

            if ( this.get('product') ) {
                filter['filter[product.id]'] = this.get('product').id;
                filter['filter[devicegroup.type]'] = 'neq:factoryfixture_devicegroup,production_devicegroup';
                return filter;
            }

            if ( this.get('owner') ) {
                filter['filter[owner.id]'] = this.get('owner').id;
                filter['filter[devicegroup.type]'] = 'neq:dut_devicegroup,factoryfixture_devicegroup,production_devicegroup';
                return filter;
            }

            if ( this.get('account') ) {
                filter['filter[account.id]'] = this.get('account').id;
                return filter;
            }

            return filter;
        },
        router_command: function() {
            if ( !this.get('product') && !this.get('owner') && !this.get('devicegroup') ){
                return 'devices';
            }
            if ( this.get('product') && !this.get('devicegroup') ){
                return 'product_devices';
            }
            if ( this.get('product') && this.get('devicegroup') ){
                return 'devicegroup_devices';
            }
            if ( this.get('product') && this.get('devicegroup_type') ){
                return 'product_devicegroup_type';
            }
            if ( this.get('owner') ){
                return 'devices_by_owner';
            }
            if ( this.get('account') ){
                return 'devices_by_owner';
            }
        }
    });

    var DevicesFilterLayout = Backbone.Marionette.View.extend( {
        template: Handlebars.compile(template),
        regions: {},
        ui: {
            filter_assigment: '.assignment .filter',
            filter_product: '.product .filter',
            filter_owner: '.owner .filter',
            filter_devicegroup: '.devicegroup .filter',
            filter_devicegroup_type: '.devicegroup_type .filter',
            filter_menu_title_assignment: '.assignment .menu-title',
            filter_menu_title_product: '.product .menu-title',
            filter_menu_title_owner: '.owner .menu-title',
            filter_menu_title_devicegroup: '.devicegroup .menu-title',
            filter_menu_title_devicegroup_type: '.devicegroup_type .menu-title',

        },
        model: new DeviceFilterModel( {} ),
        events: {
            'click @ui.filter_assigment': 'assignment',
            'click @ui.filter_product': 'product',
            'click @ui.filter_owner': 'owner',
            'click @ui.filter_devicegroup': 'devicegroup',
            'click @ui.filter_devicegroup_type': 'devicegroup_type'
        },
        initialize: function() {
            if ( this.options.filter ) {
                this.model.set('product', this.options.filter.product);
                this.model.set('assignment', this.options.filter.assignment);
                this.model.set('devicegroup', this.options.filter.devicegroup);
                this.model.set('devicegroup_type', this.options.filter.devicegroup_type);
                this.model.set('owner', this.options.filter.owner);
                this.model.set('account', this.options.filter.account);
            }
        },

        templateContext: function() {
            var assignment;
            var devicegroup;
            var devicegroup_type;
            var owner;
            var product;

            if ( this.options.filter ) {
                if ( this.options.filter.assignment ) {
                    assignment = this.options.filter.assignment;
                }
                if ( this.options.filter.devicegroup) {
                    devicegroup = this.options.filter.devicegroup;
                }
                if ( this.options.filter.devicegroup_type) {
                    devicegroup_type = this.options.filter.devicegroup_type;
                }
                if ( this.options.filter.owner ) {
                    owner = this.options.filter.owner;
                }
                if ( this.options.filter.product ) {
                    product =  this.options.filter.product;
                }
            }

            return {
                assignment : assignment || 'All',
                devicegroup : devicegroup || 'All',
                devicegroup_type : devicegroup_type || 'All',
                owner : owner || 'All',
                product : product || 'All'
            };
        },
        assignment: function(e) {
            this.model.set('assignment', e.target.rel);
            this.ui.filter_menu_title_assignment.text(e.target.text);
            this.trigger_fetch();
        },
        product: function(e) {
            this.model.set('product', e.target.rel);
            this.ui.filter_menu_title_product.text(e.target.text);
            this.trigger_fetch();
        },
        owner: function(e) {
            this.model.set('owner', e.target.rel);
            this.ui.filter_menu_title_owner.text(e.target.text);
            this.trigger_fetch();
        },
        devicegroup: function(e) {
            this.model.set('devicegroup', e.target.rel);
            this.ui.filter_menu_title_devicegroup.text(e.target.text);
            this.trigger_fetch();
        },
        devicegroup_type: function(e) {
            this.model.set('devicegroup_type', e.target.rel);
            this.ui.filter_menu_title_devicegroup_type.text(e.target.text);
            this.trigger_fetch();
        },
        trigger_fetch: function() {
            this.trigger('filter:clicked', this.model.calculate());
        }

    });
    export default DevicesFilterLayout;

